import { ExternalPayloadsService_externalPayloadsServiceGetEntity } from '@festina/unitlink-general-types/unitlink/hooks/ExternalPayloadsService_externalPayloadsServiceGetEntity'

export const useFetchFundPricesExternalPayload =
  ExternalPayloadsService_externalPayloadsServiceGetEntity.useLazyQuery
